import { normalize, schema } from 'normalizr'
import { Shipment } from 'apps/carrier/apiTypes/activeShipments'
import { GetCarrierActiveShipmentsResponse } from '../apiTypes/activeShipments'

const shipmentEntity = new schema.Entity(
  'byLaneKey',
  {},
  {
    mergeStrategy: (entityA, entityB) => {
      return {
        laneTo: entityB.laneTo,
        laneFrom: entityB.laneFrom,
        shipments: [...(entityA?.shipments || []), ...(entityB?.shipments || [])],
      }
    },
    processStrategy: value => {
      const [laneFrom, laneTo] = value.lane.split(' - ')

      return {
        shipments: [value],
        laneTo,
        laneFrom,
      }
    },
    idAttribute: value => value.lane,
  }
)

const laneShipmentSchema = new schema.Entity('response', {
  shipments: [shipmentEntity],
})

export interface IByLaneKey {
  shipments: Shipment[]
  laneTo: string
  laneFrom: string
}

interface INormalizedShipmentsSchema {
  entities: {
    byLaneKey: {
      [key: string]: IByLaneKey
    }
  }
}

const setLaneShipmentSchema = (response: GetCarrierActiveShipmentsResponse | null) => {
  if (!response) return []

  const { entities }: INormalizedShipmentsSchema = normalize(response, laneShipmentSchema)

  if (!entities.byLaneKey) return []
  const laneList = Object.values(entities.byLaneKey)

  return laneList
}

export default setLaneShipmentSchema
